import { forwardRef } from 'react';
import { InputTextarea } from "primereact/inputtextarea";

const BaseInputTextarea = forwardRef((props, ref)=>{
    return <InputTextarea {...props} ref={ref}></InputTextarea>
})

export default BaseInputTextarea;